import { Module } from 'vuex'
import { IRootState } from '@/store/types'
import { INetworkState } from '@/store/modules/network/types'
import Network from '@/js/Network'
import { dcomm } from '@/dcomm'
import { networks } from '@/config'

const currentNetwork = JSON.parse(
    localStorage.getItem('CurrentNetwork') || '{}'
)
export const DEFAULT_NETWORK_ID = parseInt(currentNetwork.networkId)
export const DEFAULT_NETWORK_NAME = currentNetwork.name.toString()
export const DEFAULT_NETWORK = currentNetwork
const explorerFEUrl = 'https://explorer.dcomm.network'
export const ethereumAPI = currentNetwork.dcommGoEthUrl || ''
export const peerInfoURL = currentNetwork.peerInfoUrl || ''
export const actChainExplorerURL = DEFAULT_NETWORK.actChainExplorerUrl || ''
export const statusUrl = currentNetwork.statusUrl || ''
const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
export let CURRENT_SUBNET = urlParams.get('subnet')?.toLowerCase() || null
export let HAS_SUBNET = CURRENT_SUBNET !== null ? true : false
const getSubnetWss = DEFAULT_NETWORK.subnets
    .map((x: any) => {
        const sub = CURRENT_SUBNET !== null ? CURRENT_SUBNET : ''
        const wssUrl = sub + '_wss'
        if (wssUrl in x) {
            return x[wssUrl]
        }
    })
    .filter((z: any) => {
        if (z) {
            return z
        }
    })
const getSubnet = DEFAULT_NETWORK.subnets
    .map((x: any) => {
        const sub = CURRENT_SUBNET !== null ? CURRENT_SUBNET : ''
        if (sub in x) {
            return x[sub]
        }
    })
    .filter((y: any) => {
        if (y) {
            return y
        }
    })
export let subnet_url = getSubnet[0]
export let subnet_wss_url = getSubnetWss[0]
if (subnet_url === undefined) {
    CURRENT_SUBNET = null
    HAS_SUBNET = false
}
const network_module: Module<INetworkState, IRootState> = {
    namespaced: true,
    state: {
        status: 'disconnected', // disconnected | connecting | connected
        networks: [],
        selectedNetwork: null,
    },
    mutations: {
        addNetwork(state, net: Network) {
            state.networks.push(net)
        },
    },
    actions: {
        async init({ state, commit, dispatch }) {
            networks.map((net) => {
                const data = new Network(
                    `${net.name}`,
                    `${net.protocol}://${net.ip}:${net.port}`,
                    net.networkId,
                    net.chainId,
                    net.indexerUrl,
                    explorerFEUrl
                )
                commit('addNetwork', data)
            })
            // initialize selected network
            try {
                const defaultNetwork = state.networks.find(
                    (network: Network) =>
                        network.networkId === DEFAULT_NETWORK_ID
                )
                await dispatch('setNetwork', defaultNetwork)
                return true
            } catch (e) {
                console.log(e)
                state.status = 'disconnected'
            }
        },
        async setNetwork({ state }, net: Network): Promise<boolean> {
            // Query the network to get network id
            state.status = 'connecting'
            dcomm.setAddress(net.ip, net.port, net.protocol)
            dcomm.setNetworkID(net.networkId)
            dcomm.ASTChain().refreshBlockchainID()
            state.selectedNetwork = net
            const data = JSON.stringify(state.selectedNetwork)
            localStorage.setItem('network_selected', data)

            state.status = 'connected'
            return true
        },
        async updateSubnet() {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)

            CURRENT_SUBNET = urlParams.get('subnet')?.toLowerCase() || null
            HAS_SUBNET = CURRENT_SUBNET !== null ? true : false
            const getSubnetWss = DEFAULT_NETWORK.subnets.map((x: any) => {
                const sub = CURRENT_SUBNET !== null ? CURRENT_SUBNET : ''
                const wssUrl = sub + '_wss'
                if (wssUrl in x) {
                    return x[wssUrl]
                }
            })
            const getSubnet = DEFAULT_NETWORK.subnets.map((x: any) => {
                const sub = CURRENT_SUBNET !== null ? CURRENT_SUBNET : ''
                if (sub in x) {
                    return x[sub]
                }
            })
            subnet_url = getSubnet[0]
            subnet_wss_url = getSubnetWss[0]
            if (subnet_url === undefined) {
                CURRENT_SUBNET = null
                HAS_SUBNET = false
            }
        },
    },
}

export default network_module
